import styled from "styled-components";

export const AudioView = styled.div<{
  $progress: number;
}>`
  display: flex;
  flex-direction: column;
  min-width: 256px;
  padding-bottom: ${({ theme }) => theme.spacing.xx_small }px;

  & > div.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    padding: ${({ theme }) => theme.spacing.x_small }px 0;
  }

  & > div.actions > button.play-pause {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing.x_small }px;
    border: none;
    border-radius: 50%;
    background-color: transparent;
    opacity: 1;
    transition: all .2s;
    color: ${({ theme }) => theme.colors.text.default };
  }

  & > div.actions > button.play-pause:disabled {
    cursor: default;
  }

  & > div.actions > button.play-pause:disabled:hover {
    background-color: transparent;
  }

  & > div.actions > button.play-pause:hover {
    background-color: ${({ theme }) => theme.colors.selected.default };
  }

  & > div.actions > button.play-pause:active {
    background-color: ${({ theme }) => theme.colors.selected.hover };
  }

  input[type="range"] {
    -webkit-appearance: none; /* Remove estilo padrão do Chrome/Safari */
    appearance: none;
    flex: 1;
    height: ${({ theme }) => theme.spacing.x_small }px;
    background: ${({ theme }) => theme.colors.selected.default };
    border-radius: 5px;
    outline: none;
    cursor: pointer;
  }

  /* Linha da barra no Chrome, Safari, Edge */
  input[type="range"]::-webkit-slider-runnable-track {
    height: ${({ theme }) => theme.spacing.x_small }px;
    background: ${({ theme, $progress }) => `linear-gradient( 90deg, ${ theme.colors.secondary.default } ${ $progress }%, ${ theme.colors.selected.default } ${ $progress }% )`};
    border-radius: ${({ theme }) => theme.spacing.x_small }px;
  }

  /* Bolinha do Chrome, Safari, Edge */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: ${({ theme }) => theme.spacing.xxx_small }px;
    height: ${({ theme }) => theme.spacing.xxx_small }px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.gray["100"] };
    margin-top: -${({ theme }) => theme.spacing.x_small }px;
    cursor: grab;
    transition: 0.2s;
  }
  input[type="range"]::-webkit-slider-thumb:active {
    cursor: grabbing;
    background: ${({ theme }) => theme.colors.gray["300"] };
  }

  /* Firefox */
  input[type="range"]::-moz-range-track {
    height: ${({ theme }) => theme.spacing.x_small }px;
    background: ${({ theme }) => theme.colors.selected.default };
    border-radius: ${({ theme }) => theme.spacing.x_small }px;
  }

  input[type="range"]::-moz-range-progress {
    background: ${({ theme }) => theme.colors.secondary.default };
    height: ${({ theme }) => theme.spacing.x_small }px;
    border-radius: ${({ theme }) => theme.spacing.x_small }px;
  }
  input[type="range"]::-moz-range-thumb {
    width: ${({ theme }) => theme.spacing.xxx_small }px;
    height: ${({ theme }) => theme.spacing.xxx_small }px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.gray["100"] };
    margin-top: -${({ theme }) => theme.spacing.x_small }px;
    cursor: grab;
    transition: 0.2s;
    border: none;
  }
  input[type="range"]::-moz-range-thumb:active {
    cursor: grabbing;
    background: ${({ theme }) => theme.colors.gray["300"] };
  }

  /* Internet Explorer */
  input[type="range"]::-ms-track {
    width: 100%;
    height: 6px;
    border-color: transparent;
    color: transparent;
    background: transparent;
  }
  input[type="range"]::-ms-fill-lower {
    background: ${({ theme }) => theme.colors.secondary.default };
    height: ${({ theme }) => theme.spacing.x_small }px;
    border-radius: ${({ theme }) => theme.spacing.x_small }px;
  }
  input[type="range"]::-ms-fill-upper {
    height: ${({ theme }) => theme.spacing.x_small }px;
    background: ${({ theme }) => theme.colors.selected.default };
    border-radius: ${({ theme }) => theme.spacing.x_small }px;
  }
  input[type="range"]::-ms-thumb {
    width: ${({ theme }) => theme.spacing.xxx_small }px;
    height: ${({ theme }) => theme.spacing.xxx_small }px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.gray["100"] };
    margin-top: -${({ theme }) => theme.spacing.x_small }px;
    cursor: grab;
    transition: 0.2s;
    border: none;
  }

  & > div.actions > div.rate > div.button-rate-view {
    height: 24px;
    overflow: hidden;
  }

  & > div.actions > div.rate > div.button-rate-view > button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.selected.default };
    color: ${({ theme }) => theme.colors.text.default };
    border-radius: ${({ theme }) => theme.border_radius.large }px;
    cursor: pointer;
    transition: background-color .2s, scale .2s;
    scale: 1;

    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }

  & > div.actions > div.rate > div.button-rate-view > button:hover {
    background-color: ${({ theme }) => theme.colors.selected.hover };
  }

  & > div.actions > div.rate > div.button-rate-view > button:active {
    scale: .8;
  }

  & > div.times {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-left: 40px;
    padding-right: ${({ theme }) => theme.spacing.xx_small }px;
    gap: ${({ theme }) => theme.spacing.xx_small }px;

    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }

  & > div.times > span.progress {
    flex: 1;
  }
`;
